module.exports = __webpack_public_path__ + "img/srp-grid-toyota.fc6dabca.png";